import { createAsyncThunk } from '@reduxjs/toolkit';
// Utilities
import HttpClient from 'utilities/HttpClient';
import { quizEventMessages } from './quizEventMessages';
import { appActions } from 'store/app/appSlice';

const _url:string = '/quizEvent'
const _http:HttpClient = new HttpClient();

export const getQuizEvents = createAsyncThunk(
  'quizzes/Get quiz events',
  async (quizId:string, { rejectWithValue }) => {
    const response:Response = await _http.get(`${_url}?quizId=${quizId}`);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);

export const createQuizEvent = createAsyncThunk(
  'quizzes/Create quiz event',
  async (data:any, { rejectWithValue, dispatch }) => {
    const response:Response = await _http.post(_url, data);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: quizEventMessages.create }));
    return response.json();
  }
);

export const updateQuizEvent = createAsyncThunk(
  'quizzes/Update quiz event',
  async (data:any, { rejectWithValue, dispatch }) => {
    const { id, ...nextData } = data;
    const response:Response = await _http.put(`${_url}/${id}`, nextData);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: quizEventMessages.update }));
    return response.json();
  }
);

export const deleteQuizEvent = createAsyncThunk(
  'quizzes/Delete quiz event',
  async (quizEventId:string, { rejectWithValue, dispatch }) => {
    const response:Response = await _http.delete(`${_url}/${quizEventId}`);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: quizEventMessages.delete }));
  }
);

export const triggerQuizEvent = createAsyncThunk(
  'quizzes/Trigger quiz event',
  async (quizEventId:string, { rejectWithValue, dispatch }) => {
    const response:Response = await _http.post(`${_url}/${quizEventId}/actions/trigger`);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: quizEventMessages.trigger }));
    return response.json();
  }
);
